export default __webpack_public_path__ + "static/media/icon_bookmark_black.16c5313c.svg";